import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-3';
import moment from 'moment'

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - AirSXM` : 'AirSXM',
  setup({el, App, props, plugin}) {

    const app =  createApp({render: () => h(App, props)})
        .use(plugin);

    app.config.globalProperties.$filters = {
        formatDate(value) {
            return moment(String(value)).format('DD-MM-YYYY HH:mm')
        },
        setFormatDate(value, format) {
            return moment(String(value)).format(format)
        },
        formatDateAmerican(value) {
            return moment(String(value)).format('DDMMMYY')
        },
        getDay(value) {
            return moment(String(value)).format('dddd')
        },
        calculateHours(departure, arrival) {
            var diff =(new Date(arrival).getTime() - new Date(departure).getTime()) / 1000;
            diff /= 60;
            var totalMinutes = Math.abs(Math.round(diff));

            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            return { hours, minutes };
        },
    }

    // app.use(TawkMessengerVue, {
    //     propertyId : '6408ad7e31ebfa0fe7f169ff',
    //     widgetId : '1gr0ubdft'
    // });

    app.mount(el);
  },
//   setup({ el, App, props, plugin }) {
//     createApp({ render: () => h(App, props) })
//       .use(plugin)
//       .mount(el)
//   },
})
